import React from 'react';
import PropTypes from 'prop-types';

import LinkWithArrow from 'components/essentials/LinkWithArrow/LinkWithArrow';
import useRandomId from 'hooks/useRandomId';

const FluidTextBlock = ({ header, text, cta }) => {
  const HeaderTag = header.tagName || 'div';
  const headerId = useRandomId('FluidTextBlock-Header-');

  return (
    <div className="text-gray">
      <span className="[border-top:2px_solid_#107c8c] box-border [content:''] block h-0 mt-[60px] mx-0 mb-5 w-[30px] md:w-10" />

      {header && (
        <HeaderTag className="text-xl font-bold mb-2.5" id={headerId}>
          {header.content}
        </HeaderTag>
      )}

      <div className="font-normal text-base">
        {text.content}
        {!!cta && cta.content && (
          <div className="text-base mt-5 font-bold">
            <LinkWithArrow
              to={cta.linkTo}
              aria-labelledby={header ? headerId : undefined}
            >
              {cta.content}
            </LinkWithArrow>
          </div>
        )}
      </div>
    </div>
  );
};

FluidTextBlock.propTypes = {
  header: PropTypes.shape({
    content: PropTypes.string,
    tagName: PropTypes.string,
  }),
  text: PropTypes.shape({
    content: PropTypes.string,
  }),
  cta: PropTypes.shape({
    content: PropTypes.string,
    linkTo: PropTypes.string,
  }),
};

export default FluidTextBlock;
